import { PromoStickyFooterContent } from '@mc/promos'
import { usePromotion } from '@mc/promo-utils'
import { useBogo } from '@mc/bogo-utils'
import { BogoStickyFooterContent } from '@mc/bogo'

import CTA from 'components/CTA'
import { trackPropsType } from 'components/CTA/events'
import { PricingText } from 'components/PricingText'

interface CTAProps {
  href?: string
  trackProps: trackPropsType
  onClick: (action: string) => void
  children: React.ReactNode
  fullWidth?: boolean
  className?: string
}

const PromotionalContentWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <div style={{ backgroundColor: 'var(--mc-color-pink-500)' }}>{children}</div>
)

export const StickyContent = ({ ctaProps }: { ctaProps: CTAProps }) => {
  const { isBogoOfferEligible } = useBogo()
  const { isPromotionOn } = usePromotion()
  const isActivePromo = isPromotionOn || isBogoOfferEligible

  const renderSignUpCTA = (signUpCtaProps?: Partial<CTAProps>) => (
    <CTA
      href={ctaProps.href}
      trackProps={ctaProps.trackProps}
      isBasic
      onClick={ctaProps.onClick}
      kind={isActivePromo ? 'play' : undefined}
      {...signUpCtaProps}
    >
      {ctaProps.children}
    </CTA>
  )

  if (isActivePromo) {
    return (
      <PromotionalContentWrapper>
        {isPromotionOn ? (
          <PromoStickyFooterContent
            SignUpCta={renderSignUpCTA}
            PricingText={() => <PricingText hidePricingMicrocopyExperiment />}
          />
        ) : (
          <BogoStickyFooterContent
            SignUpCta={renderSignUpCTA}
            PricingText={() => <PricingText hidePricingMicrocopyExperiment />}
          />
        )}
      </PromotionalContentWrapper>
    )
  }

  return (
    <div className='container d-flex align-items-center justify-content-end mc-py-4'>
      <p className='mc-text-h7 mc-opacity--hinted mc-mr-4'>
        <PricingText hidePricingMicrocopyExperiment />
      </p>
      {renderSignUpCTA()}
    </div>
  )
}
